export const getNavigationLinks = () => document.querySelectorAll('.global-navigation .global-navigation__links a.global-navigation__link');
export const getIconFromNavigationLinkElement = (element) => element.querySelector('.global-navigation__icon') || element.querySelector('.global-navigation__link-icon');
